import React from 'react';
import './Contact.css';
import facebookIcon from '../../../../assets/images/icons/facebookIcon.svg'
import telegramIcon from '../../../../assets/images/icons/telegramIcon.svg'
import whatsAppIcon from '../../../../assets/images/icons/whatsUpIcon.svg'
import instIcon from '../../../../assets/images/icons/instIcon.svg'
import meeticon from '../../../../assets/images/icons/meetIcon.svg'
import linkedInIcon from '../../../../assets/images/icons/linkedIn.svg'
import phoneIcon from '../../../../assets/images/icons/phoneIcon.svg'
import mailIcon from '../../../../assets/images/icons/mailIcon.svg'
import adressIcon from '../../../../assets/images/icons/adressIcon.svg'
import whyContactIcon1 from '../../../../assets/images/icons/whyContactIcon1.svg'
import whyContactIcon2 from '../../../../assets/images/icons/whyContactIcon2.svg'
import whyContactIcon3 from '../../../../assets/images/icons/whyContactIcon3.svg'
import whyContactIcon4 from '../../../../assets/images/icons/whyContactIcon4.svg'
import ContactFormWithBackground from '../../../../components/ContactFormWithBackgroundGray/ContactFormWithBackground';
import SEO from "../../../../utils/SEO";
import {COMPANY_ADDRESS} from "../../../../utils/companyAddress";

const Contact = () => {

    const whyContactsArray = [
        {
            id: 1,
            point: "(01)",
            title: 'Global Presence',
            img: whyContactIcon1,
            descr: 'Offices in UK, Cyprus, and Albania.'
        },
        {
            id: 2,
            point: "(02)",
            title: 'Expertise',
            img: whyContactIcon2,
            descr: 'Specialized in licensing, offshore structures, and compliance.'
        },
        {
            id: 3,
            point: "(03)",
            title: 'Proven Track Record',
            img: whyContactIcon3,
            descr: 'Offices in UK, Cyprus, and Albania.'
        },
        {
            id: 4,
            point: "(04)",
            title: 'Fast & Personalized Service',
            img: whyContactIcon4,
            descr: 'Offices in UK, Cyprus, and Albania.'
        },
    ]

    

    return (
        <main className='main'>
            <SEO
                title="Contact Offshore Advisory | Get Expert Consultation "
                description=" Contact Offshore Advisory for offshore company formation, licensing, banking, and residency solutions. Book a meeting or reach us via email or WhatsApp. "
                keywords=" contact offshore advisory, offshore consulting contact, company formation support, offshore licensing consultation, banking assistance offshore, residency advisory contact, fintech licensing help, international business services support "
                url="/contact"
            />
            <div className='contact-us-background'>
            
                <div className='contact-us-container'>
                    <div className='contact-us-left'>
                        <h2 className='contact-us-title'>
                            Contact us
                        </h2>
                        <div className='contact-us-social-row'>
                            <span className='contact-us-social-text'>
                                We are in social networks:
                            </span>
                              <a href='https://www.linkedin.com/company/offshore-advisory-ltd/'>
                                <img src={linkedInIcon} alt="LinkedIn" />
                            </a>
                            <a href='https://www.facebook.com/share/1BzUY37Eas/?mibextid=wwXIfr'>
                                <img src={facebookIcon} alt='Facebook' />
                            </a>
                            <a href='https://calendly.com/offshoreadvisory-info/30min'>
                                <img src={meeticon} alt="Book a meeting" />
                            </a>
                            {/* <a>
                                <img src={skypeIcon} />
                            </a> */}
                            <a href='https://t.me/+447385054407' >
                                <img src={telegramIcon} alt='Telegram' />
                            </a>
                            <a href='https://wa.me/447385054407'>
                                <img src={whatsAppIcon} alt='WhatsApp' />
                            </a>
                            <a href='https://www.instagram.com/globaladvisorycorp?igsh=MXQwbmloNzJmdTdweQ=='>
                                <img src={instIcon} alt='Instagram' />
                            </a>
                        </div>
                    </div>
                    <div className='contact-us-right'>
                        <div className='contact-us-item'>
                            <span className='contact-us-item-key'>
                                Phone
                            </span>
                            <div className='contact-us-item-row'>
                                <div className='contact-us-item-img'>
                                    <img src={phoneIcon} alt='Phone' />
                                    <a href='tel:+447385054407' >
                                        +447385054407
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className='contact-us-item'>
                            <span className='contact-us-item-key'>
                                Email
                            </span>
                            <div className='contact-us-item-row'>
                                <div className='contact-us-item-img'>
                                    <img src={mailIcon} alt='Email' />
                                    
                                    
                                    <div>
                                        <a href='mailto:info@offshoreadvisory.pro'>info@offshoreadvisory.pro</a>
                                        <a href='tel:compliance@offshoreadvisory.pro'>compliance@offshoreadvisory.pro</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='contact-us-item'>
                            <span className='contact-us-item-key'>
                                Address
                            </span>
                            <div className='contact-us-item-row'>
                                <div className='contact-us-item-img'>
                                    <img src={adressIcon} alt='Address' />
                                    {COMPANY_ADDRESS}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='why-contact-container'>
                <div className='why-contact-left'>
                    <h2 className='why-contact-title'>
                        Why Contact Offshore Advisory?
                    </h2>
                </div>
                <div className='why-contact-right'>
                    {whyContactsArray.map((item) => (
                        <div className='why-contact-item' key={item.id}>
                            <div className='why-contact-header-content'>
                                    <span className='why-contact-point'>
                                        {item.point}
                                    </span>
                                    <h2>
                                        {item.title}
                                    </h2>
                            </div>
                            <div className='why-contact-img-wrapper'>
                                        <img src={item.img} alt={item.title} />
                                    </div>
                                    <p className='why-contact-descr'>
                                        {item.descr}
                                    </p>
                        </div>
                    ))}
                    
                </div>
            </div>
            <ContactFormWithBackground />
            {/* <Footer /> */}
        </main>
    );
}

export default Contact;
